import { Region } from '../region';
import { IPaymentProvider } from '../../providers/payment/payment.interface'
import { PaymentProviderCyberSource } from '../../providers/payment/payment.cybersource'

/**
 * @description Geographical region the application is currently configured for, e.g. US, Spain, Australia.
 * @region Enumeration for this region.
 * @defaultCountryFrom Default value to use for send-from country, i.e. in price calculator
 * @defaultCurrencyFrom Default value to use for send-from currency, i.e. in price calculator
 * @defaultLanguage Default language culture to use, i.e. content translations
 */

export const regionValues = {

  region: Region.IT,
  regionId: 1505,
  defaultCountryFrom: 'IT',
  defaultCountryFromOnfido: 'ITA',
  defaultCountryCodeFrom: 39,
  defaultCurrencyFrom: 'EUR',
  defaultLanguageCulture: 'it-IT',
  defaultLocation: {
    latitude: 41.9028,
    longitude: 12.4964
  },
  dateFormat: 'DD/MM/YYYY',  
  postalCodeRegex:`^\\d{5}$`,
  links: {
    linkFaq: 'https://www.riamoneytransfer.com/us/en/mobile-content/faqs'
  },
  languageCultures: ['it-IT', 'en-IT'],
  regionalIp: '66.82.123.234',
  paymentProvider: <IPaymentProvider>new PaymentProviderCyberSource(),
  isPlaidEnabled: false,
  isBankAccountEnabled:false,
  useSecurityQuestions: false,
  oldRemittanceLogin: false,
  onfidoMaxAttempts: 1,
  directBankBrand:'',
  distanceMetric: 'km',
  acceptInternationalCards:true,
  stagedRiaBrand: '',
  payNearMeBrand: '',
  isEu: true,
  isEMEA: true,
  notShowMarketingPushAlert: false,
  useVeriff: true,
  googlepayAdyenPaymentNetworks: ["masterCard", "visa"],
  applepayAdyenPaymentNetworks: ["cartes_bancaires", "masterCard", "visa"],
  adyenMerchantCapability: ["debit", "3ds", "credit"],
  walletSettings:{
    isMerchantSupportEnable:false,
  },
  defaultTranslationParams: null,
  originalCountryAllowedOnly: false,
  canShowLogosOnQRScanner: false,
  airtimeServices:{
    isAirTimeSevice:false,
    isLocalOnly:false,
  },
  passCodeLength: 6,
  walletServices:[],
  isCountrySupportDecimal: true,
  showNewHomePage: true,
  autoEnableMarketingPreference: false,
  loginRootHomePage: "activity",
  adyenRegion: 'live'// https://docs.adyen.com/development-resources/live-endpoints/#client-side-environment-region
};


// WEBPACK FOOTER //
// ./src/environment/region/IT.ts